import React from 'react';
import { HelpCircle, ChevronUp, ChevronDown } from 'lucide-react';

const FaqSection = ({ faqItems, faqExpanded, setFaqExpanded, onFaqClick }) => {
  if (!faqItems.length) return null;

  return (
    <div className="mb-2" data-testid="faq-section">
      <button
        onClick={() => setFaqExpanded(!faqExpanded)}
        className="w-full flex items-center justify-between px-3 py-2 rounded-lg bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-100 hover:border-blue-200 transition-colors"
        data-testid="faq-toggle"
      >
        <span className="flex items-center gap-2 text-xs font-medium text-blue-700">
          <HelpCircle className="h-3.5 w-3.5" />
          Common Questions ({faqItems.length})
        </span>
        {faqExpanded ? <ChevronUp className="h-3.5 w-3.5 text-blue-500" /> : <ChevronDown className="h-3.5 w-3.5 text-blue-500" />}
      </button>
      {faqExpanded && (
        <div className="mt-2 space-y-1.5 max-h-[200px] overflow-y-auto">
          {faqItems.map((item, i) => (
            <button
              key={item.question || `faq-${i}`}
              onClick={() => onFaqClick(item.question)}
              className="w-full text-left px-3 py-2 rounded-lg bg-white border border-slate-100 hover:border-[#2B8FD8]/30 hover:bg-blue-50/30 transition-colors group"
              data-testid={`faq-item-${i}`}
            >
              <p className="text-xs text-slate-700 group-hover:text-[#2B8FD8] line-clamp-2 leading-relaxed">
                {item.question}
              </p>
              <span className="text-[10px] text-slate-400 mt-0.5 block">
                confidence: {Math.round((item.confidence || 0) * 100)}%
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FaqSection;
